<template>
	<div class="profile-booking-card">
		<Accordion
			v-on:toggle="
				() => {
					;((this.accordionShow = !this.accordionShow),
					(this.bookingError = false)),
						this.getBooking()
				}
			"
			:title="resvid"
			v-bind:show="this.accordionShow"
			:lightTheme="true"
			:disabled="smallBookingInfo.cancelled == 'T'"
		>
			<span
				class="profile-booking-card__tag profile-booking-card__tag--unpaid"
				slot="unpaid"
				v-if="
					parseInt(smallBookingInfo.topay) != 0 &&
					smallBookingInfo.cancelled == 'F'
				"
			>
				{{ $t('profile.bookingUnpaid') }}
			</span>
			<span
				class="profile-booking-card__tag profile-booking-card__tag--paid"
				slot="unpaid"
				v-if="
					parseInt(smallBookingInfo.topay) == 0 &&
					smallBookingInfo.cancelled == 'F'
				"
			>
				{{ $t('profile.bookingPaid') }}
			</span>
			<span
				class="profile-booking-card__tag profile-booking-card__tag--cancelled"
				slot="unpaid"
				v-if="smallBookingInfo.cancelled == 'T'"
			>
				{{ $t('profile.bookingCancelled') }}
			</span>
			<div slot="booking">
				<span class="profile-booking-card__info">
					<span class="profile-booking-card__subtitle">
						{{ $t('profile.overviewBookingsNr') }}
					</span>
					<span class="profile-booking-card__bookingnr">
						{{ smallBookingInfo.resvid }}
					</span>
				</span>
				<span class="profile-booking-card__info">
					<span class="profile-booking-card__subtitle">
						{{ $t('profile.overviewBookingsPeriode') }}
					</span>
					<span v-if="smallBookingInfo.arrivaldate != null">
						{{ smallBookingInfo.arrivaldate.split(' ')[0] }}
					</span>
				</span>
			</div>
			<!-- Boende -->
			<PageLoading v-if="loading" />
			<AlertMessage :show="bookingError">
				<p>
					Vi har just nu tekniska problem med att visa order {{ resvid }}.
					Vänligen ring
					<a href="tel:+4628096200">0280-96 200</a>
					så hjälper vi dig.
				</p>
			</AlertMessage>
			<div v-if="!loading && !bookingError">
				<div
					class="profile-booking-card__wrapper"
					v-for="(accommodation, index) in booking.accommodation"
					:key="index + 100"
				>
					<div class="profile-booking-card__booking">
						<p class="profile-booking-card__title">
							<span>{{ accommodation.title }}</span>
						</p>
						<p
							v-if="accommodation.addons.length > 0"
							class="profile-booking-card__description"
						>
							{{ $t('accommodation.including') }}:
							<template v-for="addon in accommodation.addons">
								<!-- <template v-for="(addon, index) in accommodation.addons"> -->
								<!-- <span :key="index" v-if="addon.mandatory_web == 'T'">
									{{ addon.desc2 }}
								</span> -->
								<!-- addon.mandatory_web != 'T' &&  -->

								<span :key="addon.id" v-if="parseInt(addon.qty) > 0">
									{{ addon.qty }} x {{ addon.arttext }}
								</span>
							</template>
						</p>
						<p class="profile-booking-card__date">
							<span>{{ $t('profile.bookingArrival') }}</span>
							<span>{{ accommodation.arrdate.split('T')[0] }}</span>
						</p>
						<p class="profile-booking-card__date">
							<span>{{ $t('profile.bookingDeparture') }}</span>
							<span>{{ accommodation.depdate.split('T')[0] }}</span>
						</p>
						<p
							class="profile-booking-card__date"
							v-if="
								accommodation.promotion !== undefined &&
								accommodation.promotion !== null &&
								accommodation.promotion.promotioncode !== ''
							"
						>
							<span>{{ $t('profile.bookingsCampaigncode') }}</span>
							<span>{{ accommodation.promotion.promotioncode }}</span>
						</p>
					</div>
					<div class="profile-booking-card__price">
						{{ totalAccPrice(accommodation) }} {{ currency }}
					</div>
				</div>

				<!-- Skipass -->
				<div
					class="profile-booking-card__wrapper"
					v-for="(skipass, index) in booking.skipass"
					:key="index + 200"
				>
					<div class="profile-booking-card__booking">
						<p class="profile-booking-card__title">
							<span>{{ skipass.name }}</span>
							<span v-if="skipass.guest.name">
								— {{ `${skipass.guest.name} ${skipass.guest.lastname}` }}
							</span>
						</p>
						<p class="profile-booking-card__description">
							{{ skipass.desc1 }}
						</p>
					</div>
					<div class="profile-booking-card__price">
						{{ convertFormat(skipass.price) }} {{ currency }}
					</div>
					<div class="profile-booking-card__booking">
						<p v-if="parseInt(skipass.keycard.keyprice) > 0">
							{{ $t('profile.bookingNewKeycard') }}
							<!-- QR Code -->
							<Button
								v-if="skipass.ordernumber"
								class="qr"
								@click.native="() => showQR(skipass.ordernumber, skipass.name)"
								color="dark"
								size="xsmall"
							>
								<span>{{ $t('profile.qrCode') }}</span>
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" v-bind:class="'qr'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M11 8h-1V6h1v1h2v1h-1v1h-1V8zm2 12v-1h-1v1h1zM12 5V4h-2v1h1v1h1V5zm8-1v6h-1V9h-4V4h5zm-1 4V5h-3v3h3zM5 10H4v1h2v-1H5zm0 3h1v1h1v-3H6v1H4v2h1v-1zm5 1v2h1v-2h-1zm4-10h-1v3h1V4zm0 5V8h-1v1h1zm3-2h1V6h-1v1zM7 6H6v1h1V6zm2-2v5H4V4h5zM8 5H5v3h3V5zm9 5v1h-1v-1h-2v1h-1v-1h-3V9H9v1H8v1h1v2h1v-1h1v2h1v-2h3v1h-2v1h2v1h1v-3h1v1h1v2h1v-1h1v-1h-1v-1h-1v-1h1v-1h-2zM6 18h1v-1H6v1zm-2-3h5v5H4v-5zm1 4h3v-3H5v3zm12-3v-1h-1v1h1zm0 1h-1v1h-1v-1h-1v-1h1v-1h-2v-1h-1v2h-1v1h-1v3h1v-1h1v-1h2v2h1v-1h1v1h2v-1h1v-1h-2v-1zm-9-3h1v-1H8v1zm10 2v1h1v1h1v-3h-1v1h-1zm2 4v-1h-1v1h1zm0-8v-1h-1v1h1zM18 2h4v4h2V0h-6v2zM2 6V2h4V0H0v6h2zm4 16H2v-4H0v6h6v-2zm16-4v4h-4v2h6v-6h-2z"/></svg>
							</Button>
						</p>
						<p v-if="skipass.guest.keynumber">
							{{ $t('companion.keycardHeading') }}:
							{{ skipass.guest.keynumber }}
						</p>
						<p class="profile-booking-card__date">
							<span>{{ $t('profile.bookingAvailability') }}</span>
							<span>{{ skipass.begindate.split('T')[0] }}</span>
						</p>
						<p
							class="profile-booking-card__date"
							v-if="
								skipass.promotion !== undefined &&
								skipass.promotion !== null &&
								skipass.promotion.promotioncode !== ''
							"
						>
							<span>{{ $t('profile.bookingsCampaigncode') }}</span>
							<span>{{ skipass.promotion.promotioncode }}</span>
						</p>
					</div>
					<div class="profile-booking-card__price">
						{{ convertFormat(skipass.keycard.keyprice) }} {{ currency }}
					</div>
				</div>

				<!-- Skirental -->
				<template v-for="(skirental, index) in booking.skirental">
					<div
						v-if="index == 0"
						:key="index + 300"
						class="profile-booking-card__wrapper"
					>
						<div class="profile-booking-card__booking">
							<p v-if="booking.delivery == false">
								<span v-html="$t('profile.bookingDelivery')"></span>
							</p>
							<p v-if="booking.delivery == true">
								<span v-html="$t('profile.bookingDeliveryTo')"></span>
								<span v-if="booking.delivertoaccommodation">
									{{ getDeliveryAcc(booking.delivertoaccommodation) }}
								</span>
								<span v-else-if="booking.delivertoother">
									"{{ booking.delivertoother }}"
								</span>
							</p>
						</div>
						<div
							v-if="booking.delivery == true"
							class="profile-booking-card__price"
						>
							{{ convertFormat(booking.deliveryPrice) }} {{ currency }}
						</div>
					</div>

					<div :key="index" class="profile-booking-card__wrapper">
						<div class="profile-booking-card__booking">
							<p class="profile-booking-card__title">
								<span>{{ skirental.desc1 }}</span>
								<span v-if="skirental.guest.name">
									— {{ `${skirental.guest.name} ${skirental.guest.lastname}` }}
								</span>
							</p>
							<p class="profile-booking-card__date">
								<span>{{ $t('profile.bookingAvailability') }}</span>
								<span>
									{{ skirental.startDate.split('T')[0] }} ―
									{{ skirental.endDate.split('T')[0] }}
								</span>
							</p>
						</div>
						<div class="profile-booking-card__price">
							{{ convertFormat(skirental.price) }} {{ currency }}
						</div>
					</div>
				</template>

				<!-- Skischool -->
				<div
					class="profile-booking-card__wrapper"
					v-for="skischool in booking.skischool"
					:key="skischool.id"
				>
					<div class="profile-booking-card__booking">
						<p class="profile-booking-card__title">
							<span>{{ skischool.name }}</span>
							<span v-if="skischool.guest.name">
								— {{ `${skischool.guest.name} ${skischool.guest.lastname}` }}
							</span>
						</p>
						<!--<p class="profile-booking-card__description">
							{{ skischool.name }}
						</p>-->
						<p class="profile-booking-card__date">
							<span>{{ $t('profile.bookingAvailability') }}</span>
							<span>
								{{ skischool.startDate.split('T')[0] }} ―
								{{ skischool.endDate.split('T')[0] }}
							</span>
						</p>
					</div>
					<div class="profile-booking-card__price">
						{{ convertFormat(skischool.price) }} {{ currency }}
					</div>
				</div>

				<!-- Activity -->
				<div
					class="profile-booking-card__wrapper"
					v-for="activity in booking.activities"
					:key="activity.id"
				>
					<div class="profile-booking-card__booking">
						<p class="profile-booking-card__title">
							<span>{{ activity.name }}</span>
							<span v-if="activity.guest.name">
								— {{ `${activity.guest.name} ${activity.guest.lastname}` }}
							</span>
						</p>
						<!--<p class="profile-booking-card__description">
							{{ skischool.name }}
						</p>-->
						<p class="profile-booking-card__date">
							<span>{{ $t('profile.bookingAvailability') }}</span>
							<span>
								{{ activity.startDate.split('T')[0] }} ―
								{{ activity.endDate.split('T')[0] }}
							</span>
						</p>
					</div>
					<div class="profile-booking-card__price">
						{{ convertFormat(activity.price) }} {{ currency }}
					</div>
				</div>

				<template
					v-if="
						booking.totalamounttopay - booking.payedamount != 0 &&
						booking.payedamount != 0
					"
				>
					<div class="profile-booking-card__left-to-pay">
						<div>
							<span>{{ $t('profile.bookingTotal') }}</span>
							<span>
								{{ convertFormat(booking.totalamounttopay) }}
								{{ this.booking.currency }}
							</span>
						</div>
						<div>
							<span>{{ $t('cart.paidAmount') }}</span>
							<span>
								-{{ convertFormat(booking.payedamount) }}
								{{ this.booking.currency }}
							</span>
						</div>
					</div>
					<div
						class="profile-booking-card__total-price profile-booking-card__total-price--left"
					>
						<span>{{ $t('cart.amountToPay') }}</span>
						<span>
							{{
								convertFormat(booking.totalamounttopay - booking.payedamount)
							}}
							{{ this.booking.currency }}
						</span>
					</div>
				</template>
				<div v-else class="profile-booking-card__total-price">
					<span>{{ $t('profile.bookingTotal') }}</span>
					<span>
						{{ convertFormat(booking.totalamounttopay) }}
						{{ this.booking.currency }}
					</span>
				</div>
				<div class="profile-booking-card__actions">
					<!--<Button v-if="this.booking.allowcancellation" color="dark" size="small">
					Avboka
				</Button>-->
					<Button
						v-if="this.booking.allowmodification"
						@click.native="showWarningModal('cart')"
						color="dark"
						size="small"
					>
						{{ $t('profile.bookingButtonCart') }}
					</Button>

					<Button
						:loading="pdfLoading"
						v-if="
							this.booking.payedamount == this.booking.totalamounttopay &&
							smallBookingInfo.cancelled !== 'T'
						"
						@click.native="getPdf(booking.headlid, $store.state.user.id)"
						color="dark"
						size="small"
					>
						{{ $t('profile.bookingButtonPdf') }}
					</Button>
					<Button
						v-if="this.booking.payedamount < this.booking.totalamounttopay"
						@click.native="showWarningModal('payment')"
						size="small"
					>
						{{ $t('profile.bookingButtonPayment') }}
					</Button>
				</div>
				<Modal
					v-show="showModal.QRCode"
					:disableClose="false"
					:heading="smallBookingInfo.resvid"
					@close="showModal.QRCode = false"
					:center="true"
				>
					<p>{{ qrTitle }}</p>
					<QRCode :qr="qrNumber" />
				</Modal>
			</div>
		</Accordion>

		<!-- Warning modal go to cart -->
		<Modal
			v-show="showModal.cart"
			:disableClose="true"
			:maxWidth="400"
			:heading="$t('profile.bookingButtonCart')"
			:text="$t('profile.bookingModalCart')"
			:closeCta="true"
			:closeCtaText="$t('cart.close')"
			@close="showModal.cart = false"
		>
			<template v-slot:buttons>
				<Button @click.native="goToCart(booking)">
					{{ $t('profile.bookingButtonCart') }}
				</Button>
			</template>
		</Modal>

		<!-- Warning modal go to payment -->
		<Modal
			v-show="showModal.payment"
			:disableClose="true"
			:maxWidth="400"
			:heading="$t('profile.bookingButtonPayment')"
			:text="$t('profile.bookingModalPayment')"
			:closeCta="true"
			:closeCtaText="$t('cart.close')"
			@close="showModal.payment = false"
		>
			<template v-slot:buttons>
				<a :href="booking.paymenturl">
					<Button>
						{{ $t('profile.bookingButtonPayment') }}
					</Button>
				</a>
			</template>
		</Modal>
	</div>
</template>

<script>
import store from '../../vueX/store'
import mixin from '../../mixin'
import Button from '../../components/atoms/Button'
import AlertMessage from '../../components/atoms/AlertMessage'
import Accordion from '../../components/molecules/Accordion.vue'
import Modal from '../../components/molecules/Modal'
import PageLoading from '../../components/atoms/PageLoading'
import QRCode from '../../components/atoms/QRCode'

export default {
	name: 'ProfileBookingsCard',
	store,
	mixins: [mixin],
	components: {
		Button,
		Accordion,
		Modal,
		PageLoading,
		AlertMessage,
		QRCode
	},
	props: {
		smallBookingInfo: {
			type: Object,
			default: () => {}
		},
		resvid: {
			type: String,
			default: ''
		},
		isPaid: {
			type: Boolean,
			default: false
		},
		currency: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			showModal: {
				cart: false,
				payment: false,
				QRCode: false
			},
			qrNumber: '',
			qrTitle: '',
			booking: {},
			accordionShow: false,
			bookingError: false,
			loading: false,
			pdfLoading: false
		}
	},
	methods: {
		convertFormat(price) {
			return new Intl.NumberFormat(this.$t('currency')).format(price)
		},
		showQR(number, title) {
			this.qrNumber = number
			this.qrTitle = title
			this.showModal.QRCode = true
		},
		totalAccPrice(accommodation) {
			let price = 0
			let addonsArray = accommodation.addons

			for (let i = 0; i < addonsArray.length; i++) {
				//If not included in price, add addon price
				if (addonsArray[i].mandatory_web === false) {
					price += parseInt(addonsArray[i].aprice * addonsArray[i].qty)
				}
			}
			price = price + accommodation.price
			return new Intl.NumberFormat(this.$t('currency')).format(price)
		},
		getDeliveryAcc(unitlid) {
			const accommodationName = this.booking.accommodation.filter(obj => {
				return obj.unitlid == unitlid
			})
			return accommodationName[0].title
		},
		showWarningModal(type) {
			if (type == 'cart') {
				this.showModal.cart = true
			}
			if (type == 'payment') {
				this.showModal.payment = true
			}
		},
		goToCart(booking) {
			store.dispatch('ADD_BOOKING_TO_CART', booking).then(() => {
				this.$router.push({ name: 'cart' })
			})
		},
		getPdf(id, user) {
			this.pdfLoading = true
			store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(response => {
				if (response) {
					store
						.dispatch('GET_PDF_INVOICE', { headlid: id, payerlid: user })
						.then(success => {
							this.pdfLoading = false
							window.open(success, '_blank', '')
						})
				} else {
					this.pdfLoading = false
				}
			})
		},
		getBooking() {
			if (this.accordionShow) {
				this.loading = true
				store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(response => {
					if (response) {
						store.dispatch('GET_BOOKING', this.resvid).then(success => {
							if (success) {
								this.booking = success
							} else {
								this.bookingError = true
							}
							this.loading = false
						})
					} else {
						this.accordionShow = false
						this.loading = false
					}
				})
			}
		}
	},
	computed: {},
	created() {
		if (this.$route.params.id == this.resvid) {
			this.accordionShow = true
			this.getBooking()
		}
	}
}
</script>

<style scoped lang="scss">
.profile-booking-card {
	&__wrapper {
		border-top: 1px solid $colorGrey4;
		padding-top: 20px;
		margin-bottom: 20px;
		display: flex;
		/*justify-content: space-between;*/
		flex-flow: row wrap;
	}
	.qr {
		display: inline-flex;
		justify-content: space-between;
		align-items: center;
		svg {
			fill: white;
			margin-left: 10px;
		}
		@include for-phone-only {
			svg {
				margin-left: 0;
			}
			span {
				display: none;
			}
		}
	}
	&__tag {
		color: $colorWhite;
		font-size: 9px;
		font-weight: 600;
		line-height: 14px;
		padding: 3px 10px;
		border-radius: 4px;
		margin-left: 10px;
		text-transform: uppercase;
		&--paid {
			background: $colorGreen;
		}
		&--unpaid {
			background: $colorRed;
		}
		&--cancelled {
			background: $colorGrey6;
		}
	}
	&__booking {
		width: 75%;
	}
	&__price {
		width: 25%;
		text-align: right;
	}
	&__title {
		margin: 0;
		span {
			font-weight: bold;
		}
	}
	&__date {
		color: #697791;
		font-size: 12px;
		letter-spacing: 0;
		line-height: 14px;
		margin: 10px 0;
		span:first-child {
			width: 80px;
			display: inline-block;
			padding-right: 10px;
		}
	}
	&__total-price {
		padding: 30px 0;
		margin: 20px 0 40px 0;
		text-align: right;
		border: 1px solid #ccc;
		border-width: 1px 0px 1px 0px;
		span:first-child {
			display: inline-block;
			padding-right: 10px;
		}
		span:last-child {
			color: #43444a;
			font-size: 28px;
			font-weight: 500;
			letter-spacing: 0;
			line-height: 32px;
		}
		&--left {
			border-width: 1px 0px 0px 0px;
		}
	}
	&__left-to-pay {
		padding: 20px 0 0 0;
		margin: 20px 0 0 0;
		text-align: right;
		border: 1px solid #ccc;
		border-width: 1px 0px 0px 0px;
		span:first-child {
			display: inline-block;
			padding-right: 10px;
		}
		span:last-child {
			color: #43444a;
			font-size: 20px;
			font-weight: 500;
			letter-spacing: 0;
			line-height: 32px;
		}
	}
	&__actions {
		display: flex;
		flex-wrap: wrap;
		button {
			margin: 10px 10px 0 0;
			&:last-child {
				@include for-phone-only {
					margin-left: 0;
				}
				margin-left: auto;
				margin-right: 0;
			}
		}
	}
	&__subtitle {
		color: #949eb1;
		font-size: 12px;
		letter-spacing: 0;
		line-height: 19px;
	}
	&__description {
		margin: 5px 0;
		span::after {
			content: '|';
		}
		span:last-child:after {
			content: '';
		}
	}
	&__info {
		display: inline-block;
		margin-right: 20px;
		span {
			display: block;
		}
		span:last-child {
			color: #748097;
		}
	}
	&__bookingnr {
		font-weight: 600;
	}
}
</style>
